import { useEffect, useState } from "react";
import { IPayment } from "../../../globals/interfaces";

interface AltStorage {
    altStorage: boolean; 
    altStorageAmount: number;
}

type AltStorageMap = Record<string, AltStorage>;

export default function useAltStorage (
    payments: Array<IPayment>
) {
    
    const [altStorage, setAltStorage] = useState<AltStorageMap>({});

    useEffect(() => {
        const altStorage: AltStorageMap = {};

        for (let i = 0; i < payments.length; i++) {
            const { s_payment_type, s_payment_method, s_flight_id, f_amount } = payments[i];
            if (s_payment_type === 'STORAGE' && s_payment_method === 'CHARGE') {
                altStorage[s_flight_id] = {
                    altStorage: true, 
                    altStorageAmount: f_amount
                }
            }
        }
        setAltStorage(altStorage);
    }, [payments]);

    return {
        altStorage
    }
}